<template>
    <div class="pa-4 text-center">
        <v-dialog :model-value="getDialog" max-width="600" persistent>
            <v-form>
                <v-card>
                    <v-card-title class="bg-aqua-teal text-wrap"> Writing notes for: {{ title }}</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-textarea label="Add Task Notes" v-model="notes" clearable
                                outlined />
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <div class="d-flex justify-center">
                            <v-btn class="bg-aqua-teal mr-2 pa-auto" @click="closeDialog">
                                Close
                            </v-btn>
                            <v-btn class="bg-bright-orange" @click="saveNotes">
                                Save
                            </v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-form>

        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "TaskNotesForm",
    data() {
        return {
            notes: "",
            rules: {
                // This rule verifies string is non-empty (excluding whitespaces)
                text: v => v.trim().length > 0,
            }
        }
    },
    emits: ['closeDialog', 'saveNotes'],
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        text: {
            type: String,
            default: ""
        }
    },
    computed: {
        getDialog(){
            if (this.dialog) {
                if (this.text != null) {
                    // eslint-disable-next-line
                    this.notes = this.text;
                }
            }
            return this.dialog;
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        },
        saveNotes() {
            /* Emit notes to parent, if valid */
            if (this.rules.text(this.notes)){
                this.$emit('saveNotes', this.notes);
            } else {
                /* Else, emit null */
                this.$emit('saveNotes', null);
            }
        }
    }
}
</script>

<style scoped>
.bg-aqua-teal {
    background-color: #08b6aa;
}

.bg-bright-orange {
    background-color: #ff6d44;
    color: white;
}
</style>